import { Record } from 'immutable';
import { actionTypes } from './auth.actions';
import { Err } from '../err';

export const UserState = Record({
  id: null,
  firstName: null,
  lastName: null,
  email: null
});

export const SessionState = Record({
  token: null,
  type: null,
  isParticipant: false,
  isPortalAdmin: false
});

export const TenantState = Record({
  id: null,
  name: null,
  logoUrl: null,
  siteId: null,
  programId: null,
  touchpoints: null
});

export const CurrentSessionState = Record({
  session: null,
  tenant: TenantState({}),
  user: null,
  programs: null
});

export const AuthReducerState = Record({
  err: null,
  isAuthenticated: false,
  useLoginModal: false,
  isFetching: false,
  authToken: null,
  currentSession: null,
  justLoggedOut: false
});

export const authReducer = (state = new AuthReducerState({
  authToken: localStorage.getItem('portalAdminAuthToken') || null
}), action) => {
  switch (action.type) {
    case actionTypes.DELETE_CURRENT_SESSION_SUCCESS:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', false)
                  .set('currentSession', null);
    case actionTypes.DELETE_CURRENT_SESSION_FAILURE:
      return state.set('isFetching', false)
                  .set('err', action.err);
    case actionTypes.INVALIDATE_CURRENT_SESSION:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', false);
    case actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', true);
    case actionTypes.FETCH_CURRENT_SESSION_BEGIN:
      return state.set('isFetching', true)
                  .set('currentSession', null)
                  .set('err', null);
    case actionTypes.FETCH_CURRENT_SESSION_SUCCESS:
      return state.set('isFetching', false)
                  .set('isAuthenticated', true)
                  .set('currentSession', action.data)
                  .set('useLoginModal', false);
    case actionTypes.FETCH_CURRENT_SESSION_FAILURE:
    case actionTypes.VERIFY_CURRENT_SESSION_FAILURE:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('currentSession', null)
                  .set('authToken', null)
                  .set('err', action.err);
    case actionTypes.LOGOUT:
      return state.set('isFetching', true)
                  .set('justLoggedOut', true);
    case actionTypes.LOGOUT_RESET:
      return state.set('justLoggedOut', false);
    case actionTypes.CREATE_ETO_SESSION_BEGIN:
      return state.set('err', null)
                  .set('isFetching', true)
                  .set('authToken', null);
    case actionTypes.CREATE_ETO_SESSION_SUCCESS:
      return state.set('err', null)
                  .set('authToken', action.data.token)
                  .set('isFetching', false);
    case actionTypes.CREATE_ETO_SESSION_FAILURE:
      return state.set('err', new Err(action.err))
                  .set('isFetching', false)
                  .set('authToken', null);
    default:
      return state;
  }
}
